import { render } from "./PosSales.vue?vue&type=template&id=72962054&scoped=true"
import script from "./PosSales.vue?vue&type=script&lang=js"
export * from "./PosSales.vue?vue&type=script&lang=js"

import "./PosSales.vue?vue&type=style&index=0&id=72962054&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72962054"]])

export default __exports__